<div class="section">
    <div class="courses-grid">
      <button
        type="button"
        class="courses-grid__action"
        *ngFor="let course of courses()"
        (click)="openCourse(course.id)"
      >
        <app-course-card [course]="course" ></app-course-card>
      </button>
    </div>
</div>

